import { useEffect, useRef, useState } from 'react';

export const useResizeHeight = (isOpen: boolean): { ref: React.RefObject<HTMLDivElement>; containerHeight: number } => {
  const ref = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    if (!ref.current) return undefined;

    const observer = new ResizeObserver((entries) => {
      const [entry] = entries;
      if (entry) setContainerHeight(entry.contentRect.height);
    });

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [isOpen]);

  return { ref, containerHeight };
};
